<template>
  <div class="page">
    <div class="top-img">
      <img src="@/assets/new/newCopy/icon01.png" alt="">
    </div>
    <div class="section">
      <div class="page-service">
        <img :src="PayImgUrl" alt="">
      </div>
      <div class="page-payment">
        <div class="name">支付方式</div>
        <van-radio-group v-model="radio">
          <van-cell-group>
            <template v-for="(item, index) in payTypeList">
              <van-cell v-if="item !== 'aliCollectConfig' && item !== 'yeCollectConfig'&& item !== 'jdCollectConfig'
             && item !== 'aliCollectConfig'" title="微信支付" clickable
                class="wx-icon" :key="index">
                <template #right-icon>
                  <van-radio :name="item" />
                </template>
              </van-cell>
              <!-- <van-cell title="支付宝" v-if="item === 'aliCollectConfig'" clickable class="ali-icon" :key="index">
                <template #right-icon>
                  <van-radio name="aliCollectConfig" />
                </template>
              </van-cell> -->
            </template>
          </van-cell-group>
        </van-radio-group>
      </div>
      <van-button type="primary" block round color="#397EF5" @click="sumbit">支付{{ total }}元 立即激活</van-button>
    </div>
    <div v-html="payUrl"></div>
    <div class="shareit" v-if="is_WeChat">
      <img class="arrow" src="@/assets/img/arrowhead.png" />
      <div class="follow">支付宝支付请右上角点击 在游览器打开 进行支付,<br />支付成功后 请重新扫码登录进行激活操作<br /></div>
    </div>
  </div>
</template> 
<script>
import { Toast,Dialog  } from "vant";
import { wxRequest } from "@/api/user.js";
export default {
  data() {
    return {
      PayImgUrl: localStorage.getItem("PayImgUrl"), //页面地址
      radio: '',
      total: localStorage.getItem('payPrice'),
      payUrl: '',
      is_WeChat: false,
      payTypeList: [],
    }
  },
  created() {
    this.is_WeChat = false
    if (this.$route.query.row) {
      this.payUrl = JSON.parse(decodeURIComponent(this.$route.query.row))
      this.$nextTick(() => {
        document.forms[0].submit()
      })
    }
    wxRequest("/order/pay/chanle", { iccid: localStorage.getItem("iccid"),ali:localStorage.getItem("htmlType") }, "post").then((res) => {
      if (res.data.code === '200') {
        for (let i = 0; i < res.data.data.length; i++) {
          this.payTypeList.push(res.data.data[i].typeKey);
        }
        this.radio = res.data.data[0].typeKey
      }
    });
  },
  methods: {
    sumbit() { 
      var params = {
        iccid: this.$store.state.iccid ? this.$store.state.iccid : localStorage.getItem("iccid"),
        amount: 100 * 100, //固定值
        giftBalance: 0, //固定值
        yucun: 1, //固定值
        payType: 20, // 固定微信支付
      };
      var postUrl = "order/user/create/priceOrder";
      if (this.radio === 'aliCollectConfig') {   //支付宝支付
        postUrl = "order/ali/user/create/priceOrder";
        params.payType = 80;
      } else if (this.radio === 'hfCollectConfig') {  //汇丰支付
        postUrl = "order/user/create/priceOrderHf";
        params.payType = 60;
      } else if (this.radio === 'miCollectConfig') {  //米花支付
        postUrl = "order/ali/user/create/priceOrder/mi";
        params.payType = 90;
      } else if (this.radio === 'dhCollectConfig') {  //斗洪支付
        postUrl = "order/ali/user/create/priceOrder/dh";
        params.payType = 90;
      }else if (this.radio === 'hlCollectConfig') {  //斗洪支付
        postUrl = "order/ali/user/create/priceOrder/hl";
        params.payType = 90;
      }else if (this.radio === 'yyCollectConfig') {  //斗洪支付
        postUrl = "order/ali/user/create/priceOrder/yy";
        params.payType = 92;
      }else if (this.radio === 'longCollectConfig') {  //斗洪支付
        postUrl = "order/ali/user/create/priceOrder/long";
        params.payType = 93;
      }
      wxRequest(postUrl, params, "post").then((res) => {
        if (res.data.code == 200) {
          if (params.payType == 50) {
            //乐刷de
            window.location.href = res.data.data.jspay_url;
          }else if (params.payType == 92||params.payType == 93) {
            //乐刷de
            window.location.href = res.data.data;
          } else if (params.payType == 20) {
            //微信第三方
            var param = res.data.data.param;
            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener( "WeixinJSBridgeReady", this.onBridgeReady, false )
              } else if (document.attachEvent) {
                document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady)
                document.attachEvent( "onWeixinJSBridgeReady",  this.onBridgeReady  )
              }
            } else {
              this.onBridgeReady(param);
            }
          } else if (params.payType == 90) {
            //微信第三方
            var param = res.data.data;
            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener("WeixinJSBridgeReady", this.onBridgeReady,false)
              } else if (document.attachEvent) {
                document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady)
                document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady)
              }
            } else {
              this.onBridgeReady(param);
            }
          } else if (params.payType == 60) {
            //汇付天下
            let datas = JSON.parse(res.data.data);
            if (datas.status === "succeeded") {
              let payment = datas;
              AdaPay.doPay(payment, (res) => {
                Dialog.alert({ title: "提示", message: res.result_message });
              });
            }
          } else if (params.payType == 80) {
            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
              //进入引导页
              this.is_WeChat = true;
              var timer = setInterval(() => {
                clearInterval(timer);
                this.$router.push({
                  path: "/new/serviceCenter",
                  query: {
                    row: encodeURIComponent(JSON.stringify(res.data.data)),
                  },
                });
              }, 1000);
            } else {
              this.payUrl = res.data.data;
              this.$nextTick(() => {
                document.forms[0].submit();
              });
            }
          }
        } else {
          Dialog.alert({ message: res.data.message });
        }
      });
      //支付成功之后页面跳转
      //  this.$router.push({path: ''}); 
    },
  
   onBridgeReady(param) {
    let _this = this;
    WeixinJSBridge.invoke("getBrandWCPayRequest", param, function (res) {
      if (res.err_msg == "get_brand_wcpay_request:ok") {
        _this.$router.push({path: "/new/order", query: {iccid: _this.$store.state.iccid}})
      }
    });
  },


  
  },
 
}
</script>
<style lang="less" scoped>
.page {
  background: #F4F6FA;
  height: 100%;
  position: relative;

  .top-img {
    width: 100%;
    height: 206px;

    img {
      height: 100%;
      width: 100%;
    }
  }

  .section {
    width: 93%;
    margin: 12px auto;

    .page-service {
      width: calc(100% - 22px);
      padding: 11px;
      border-radius: 10px;
      background: #fff;

      img {
        height: 150px;
        width: 100%;
      }
    }

    .page-payment {
      border-radius: 10px;
      background: #fff;
      margin-top: 10px;
      width: calc(100% - 22px);
      padding: 11px;
      margin-bottom: 38px;

      .name {
        padding-bottom: 18px;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #28292D;
        line-height: 25px;
      }
    }

    .wx-icon {
      background: url('./../../assets/new/newCopy/icon03.png') left center no-repeat;
      background-size: 26px 21px;
      padding-left: 35px;
    }

    .ali-icon {
      background: url('./../../assets/new/newCopy/icon02.png') left center no-repeat;
      background-size: 26px 26px;
      padding-left: 35px;
    }

    .van-cell::after {
      border: none;
    }

    ::v-deep .van-cell-group::after {
      border: none;
    }
  }
}

.shareit {
  -webkit-user-select: none;
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  text-align: center;
  top: 0;
  left: 0;
  z-index: 999;
}

.shareit img {
  max-width: 100%;
}

.arrow {
  width: 100px;
  height: 150px;
  position: absolute;
  right: 5%;
  top: 1%;
}

.follow {
  margin-right: 6px;
  margin-left: 30px;
  width: 90%;
  // height: 100rpx;
  line-height: 30px;
  // text-align: left;
  text-decoration: none;
  font-size: 18px;
  color: white;
  float: left;
  margin-top: 180px;
}</style>